export const ENV = {
  AWS_USER_POOL_ID: import.meta.env.VITE_AWS_USER_POOL_ID,
  AWS_USER_POOL_CLIENT_ID: import.meta.env.VITE_AWS_USER_POOL_CLIENT_ID,
  AWS_REGION: import.meta.env.VITE_AWS_REGION,
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  WEBSOCKET_URL: import.meta.env.VITE_WEBSOCKET_URL,
  // App URLs Configuration
  ADMIN_APP_URL: import.meta.env.VITE_ADMIN_APP_URL,
  DASHBOARD_APP_URL: import.meta.env.VITE_DASHBOARD_APP_URL,
  // Jira Feedback Configuration
  JIRA_COLLECTOR_URL: import.meta.env.VITE_JIRA_COLLECTOR_URL,
  JIRA_COLLECTOR_HTML_URL: import.meta.env.VITE_JIRA_COLLECTOR_HTML_URL,
  JIRA_COLLECTOR_ID: import.meta.env.VITE_JIRA_COLLECTOR_ID,
  JIRA_BASE_URL: import.meta.env.VITE_JIRA_BASE_URL,
  JIRA_SERVICE_DESK_URL: import.meta.env.VITE_JIRA_SERVICE_DESK_URL,
  // Sentry Configuration
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  SENTRY_ORG: import.meta.env.VITE_SENTRY_ORG,
  SENTRY_PROJECT: import.meta.env.VITE_SENTRY_PROJECT,
  SENTRY_AUTH_TOKEN: import.meta.env.VITE_SENTRY_AUTH_TOKEN,
  // QPA Configuration
  QPA_URL: import.meta.env.VITE_QPA_URL,
} as const
